import React from "react";

interface ConfirmationModalProps {
    open: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    open,
    title = "Confirm Action",
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    onConfirm,
    onCancel,
    loading = false,
}) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 border border-yellow-300">
                
                {/* Title */}
                <h2 className="text-lg font-semibold text-green-800 mb-3">
                    {title}
                </h2>

                {/* Message */}
                <p className="text-sm text-gray-700 mb-6">
                    {message}
                </p>

                {/* Actions */}
                <div className="flex justify-end space-x-3">
                    <button
                        className="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        {cancelText}
                    </button>

                    <button
                        className="px-4 py-2 text-sm rounded-md bg-green-700 text-white hover:bg-green-800 disabled:opacity-60"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? "Processing..." : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;

